export default __webpack_public_path__ + "static/media/ProductBundleUpload.ef415478.xlsx";